import type { TitleProjectInput } from '@noconflict/contracts';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../../shared/api/supabase';
import { getTitleProject, updateTitleProject } from './api';

export const titleProjectKeys = {
  one: (projectId: string) => ['title-project', projectId] as const,
};

export const useTitleProject = (projectId: string, enabled = true) =>
  useQuery({
    queryKey: titleProjectKeys.one(projectId),
    queryFn: () => getTitleProject(supabase, projectId),
    enabled,
  });

/** The title names the project, so the project lists are refreshed with the details. */
export function useUpdateTitleProject(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: TitleProjectInput) => updateTitleProject(supabase, projectId, input),
    onSuccess: () =>
      Promise.all([
        qc.invalidateQueries({ queryKey: titleProjectKeys.one(projectId) }),
        qc.invalidateQueries({ queryKey: ['projects'] }),
      ]),
  });
}
